import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 4H15.5V1H17V4H20.25C20.6642 4 21 4.33579 21 4.75V20.25C21 20.6642 20.6642 21 20.25 21H1.75C1.33579 21 1 20.6642 1 20.25V4.75C1 4.33579 1.33579 4 1.75 4H5V1H6.5V4ZM2.5 19.5V10H19.5V19.5H2.5ZM19.5 8.5H2.5V5.5H19.5V8.5Z"
    />
  </svg>
);
